export const formTypes = {
    SIGNUP: 'signUp',
    SIGNIN: 'signIn',
    PASSWORD_RECOVERY: 'passwordRecovery',
    UPDATE_PASSWORD: 'updatePassword'
};